import {api, auth} from '../resources'
import router from '../../router'
import Vue from 'vue'
import jwt_decode from 'jwt-decode'

function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}


export default {
    namespaced: true,
    state: {
        fp: {
            result: '',
            components: []
        },
        status: '',
        token: {
            access_exp: '',
            refresh: getCookie('_refresh_token') || ''
        },
        user: {}
    },
    getters: {
        isLoggedIn: state => !!state.token.refresh
    },
    actions: {
        getStatus() {
            return auth.status.get();
        },
        register({commit}, user) {
            return api.users.save(user);
        },

        login({commit}, auth_data) {
            //auth data - {username,password,fingerprint}
            return auth.login.save(auth_data);
        },

        refresh_tokens({commit}, refresh_data) {
            //refresh_data - {refresh_token, fingerprint}
            return auth.refresh.save(refresh_data);
        },

        async logout({commit}, data) {
            //data - {token ,user_id}
            //clear settings info
            localStorage.removeItem('settings')

            const res = await auth.logout.save(data);
            if (res.body.success) {
                commit('logout')
                router.push({name: 'login'});
            } else {
                console.log(res);
            }
        },
        async logoutDemoAccount({commit}) {
            localStorage.removeItem('settings')
            commit('logout')
            window.location.href = window.location.origin;
        },

        restore({commit}, data) {
            return auth.password_restore.save(data);
        },

        reset_password({commit}, data) {
            return auth.password_reset.save(data);
        },

        verifyEmail({}, data) {
            return auth.verify_email.save({token: data});
        }
    },
    mutations: {
        setAccessToken(state, access_token) {
            Vue.http.headers.common['Authorization'] = 'Bearer ' + access_token;
            const decoded_token = jwt_decode(access_token)
            state.token.access_exp = decoded_token.exp;
            state.user = decoded_token;
        },
        setRefreshToken(state, r_token) {
            Vue.$cookies.set('_refresh_token', r_token);
            state.token.refresh = r_token;
        },
        setFingerPrint(state, {result, components}) {
            state.fp.result = result;
            state.fp.components = components;
        },
        logout(state) {
            Vue.$cookies.remove('trans_acc_id');
            Vue.$cookies.remove('trans_date');
            state.status = '';
            state.token = {
                access_exp: '',
                refresh: ''
            };
            Vue.$cookies.remove('_refresh_token');
            delete Vue.http.headers.common['Authorization'];
        }
    },

}
